module.exports = __webpack_public_path__ + "static/media/tip.28740fda.svg";